import { useEffect } from 'react';
import { useAuth } from '../lib/auth.jsx';
import { useTheme } from '../lib/theme.jsx';

/**
 * Aligne le thème affiché sur celui du compte, dès que le compte est connu.
 *
 * Ne dessine rien. C'est le seul point où les deux contextes se rencontrent :
 * le thème seul n'a pas à connaître l'authentification, et inversement.
 *
 * L'effet ne se déclenche que sur un changement venant du *compte*. S'il
 * écoutait aussi le thème local, le réglage depuis les préférences ferait un
 * aller-retour visible : l'écran passerait au sombre au clic, puis
 * reviendrait au clair le temps que le serveur enregistre le changement.
 */
export function ThemeDuCompte() {
  const { user } = useAuth();
  const { choisirTheme } = useTheme();

  useEffect(() => {
    if (user?.theme) choisirTheme(user.theme);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id, user?.theme]);

  return null;
}
